export const USER_RESOURCE = 'Users'
export const PGY_RESOURCE = 'PgyLevels'
export const CATEGORIES_RESOURCE = 'Categories'
export const FLASHCARDS_RESOURCE = 'FlashCards'
export const ADMINS_RESOURCE = 'AdminRequests'
